// Donors list page (CHG-1225 / ITER-3347; wizard trigger added CHG-1247).
//
// Thin per .forge/plans/v2-canary-pages.md §6 success criterion: page
// files ≤50 LOC, all configuration in @generated/screens. Future generator
// regenerates donorListConfig from donor.entity-hint.yaml without
// touching this file.
//
// CHG-1247 addition: floating "New donor" trigger button + conditional
// DonorCreateWizard mount. Additive only — ListPage and donor-list config
// UNCHANGED.
//
// Spec: specs/tier-05-experience/donors-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { donorListConfig } from "../generated/screens/donor-list";
import { DonorCreateWizard } from "../wizards/donor-create.generated";
import { WizardTriggerButton } from "../wizards/WizardTriggerButton";
import { useWizard } from "../wizards/useWizard";
import { wizardRegistry } from "../wizards/wizardRegistry";

export function Donors() {
  const wizard = useWizard("donor-create");
  return (
    <>
      <ListPage config={donorListConfig} />
      <WizardTriggerButton
        label="New donor"
        onClick={wizard.open}
        requirePermission={wizardRegistry["donor-create"].manifest.trigger.permission}
        testId="trigger-donor-create"
      />
      <DonorCreateWizard open={wizard.isOpen} onClose={wizard.close} />
    </>
  );
}
